import { LiveClassHistoryResponse } from '../models/LCHistoryPageLiveClass';
import api from './index';

const getLiveClassHistory = async () => {
  const { data } = await api.get<LiveClassHistoryResponse>(`/v4/live-class-history`);
  return data;
};

export const LiveClassHistoryService = {
  getLiveClassHistory,
};
